import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-reset\"><path d=\"M524.8 106.688c-106.688 0-209.088 42.624-285.888 110.912L230.4 149.312c0-25.6-21.312-42.624-46.912-38.4-25.6 0-42.688 21.376-38.4 46.976l8.512 115.2A106.88 106.88 0 0 0 260.288 371.2H268.8L384 362.688c25.6 0 42.688-21.376 38.4-46.976 0-25.6-21.312-42.624-46.912-38.4L290.112 281.6c64-55.488 145.088-89.6 230.4-89.6 187.776 0 341.376 153.6 341.376 341.312 0 187.776-153.6 341.376-341.376 341.376-187.712 0-341.312-153.6-341.312-341.376 0-25.6-17.088-42.624-42.688-42.624s-42.624 17.024-42.624 42.624C93.888 768 285.888 960 520.512 960 755.2 960 947.2 768 947.2 533.312c4.288-234.624-187.712-426.624-422.4-426.624z\" p-id=\"2850\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/reset.svg
// module id = kaIC
// module chunks = 41